export default __webpack_public_path__ + "static/media/industrial-mixers.ad4fc4f9.jpg";